import formResponseValues from '../responseConfigs/form-response-values';
import moment from 'moment';
import { shouldHideFollowUps } from '../../containers/FormFramework/utils/conditional-follow-up-helpers';
import { WORKLOG_EXCLUSIONS } from './worklogExclusions';

const parseFormElement = (element, responseArray, photoArray, fullForm, isFollowUp = false) => {
  const responseType = formResponseValues[element.type];

  if (responseType !== undefined) {
    if (element.type === 'additive') {
      responseArray.push(`${element.title} : To view, open this ticket in the mobile app`);
    }
    if (element[responseType] !== undefined) {
      switch (responseType) {
        case 'selectedIndex': {
          const res = element.options[element[responseType]].title;
          responseArray.push(`${element.title} : ${res}`);
          element.options.forEach(option => {
            if (option.title === res) {
              option.follow_up &&
                option.follow_up.forEach(element => {
                  parseFormElement(element, responseArray, photoArray, fullForm, true);
                });
            }
          });
          break;
        }
        case 'selectedValue': {
          responseArray.push(`${element.title} : ${element[responseType]}`);
          break;
        }
        case 'leftSelectedIndices': {
          let multiSelectResponseArray = [];
          let tmpResponseArray = [];
          element[responseType].forEach(res => {
            const optionsKey = element.leftSelectionOptions ? 'leftSelectionOptions' : 'options';
            multiSelectResponseArray.push(element[optionsKey][res].title);
            if (element[optionsKey][res].follow_up) {
              element[optionsKey][res].follow_up.forEach(element => {
                parseFormElement(element, tmpResponseArray, photoArray, fullForm, true);
              });
            }
          });
          responseArray.push(...tmpResponseArray);
          responseArray.push(`${element.title} : ${multiSelectResponseArray}`);
          break;
        }
        case 'photoIdentifiers':
          photoArray.push(element);
          break;
        case 'selectedDate': {
          // TODO add sectionHeaders into response format?
          const date = moment(element.selectedDate).format('MM/DD/YYYY hh:mm a');
          responseArray.push(`${element.title} : ${date}`);
          break;
        }
        case 'is_checked':
          {
            const elementId = element.element_id.toLowerCase();

            // Skip rendering checkboxes that match worklog exclusion patterns
            if (element.checkboxText) {
              const shouldExclude = WORKLOG_EXCLUSIONS.checkboxTextPatterns.some(pattern =>
                element.checkboxText.includes(pattern)
              );
              if (shouldExclude) {
                break;
              }
            }

            let resultForResponse = '';
            if (elementId.includes('hookup')) {
              const text = element.element_id.substring(0, element.element_id.indexOf('Hookup'));
              if (element.is_checked) resultForResponse = text;
            } else {
              if (isFollowUp) {
                if (element.is_checked === true) {
                  resultForResponse = 'Yes';
                }
              } else {
                resultForResponse = `${element[responseType] ? 'Yes' : 'No'}`;
              }
            }

            if (resultForResponse.length > 0) {
              responseArray.push(`${element.checkboxText}: ${resultForResponse}`);
            }

            if (
              element.is_checked &&
              element.follow_up &&
              !shouldHideFollowUps(element, fullForm)
            ) {
              element.follow_up.forEach(option => {
                parseFormElement(option, responseArray, photoArray, fullForm, true);
              });
            }
          }
          break;
        case 'additional_form': {
          // Handle subform elements
          const subformConfig = element[responseType];
          if (subformConfig && subformConfig.sections) {
            // Parse each section in the subform
            subformConfig.sections.forEach(section => {
              if (section.elements) {
                section.elements.forEach(subElement => {
                  parseFormElement(subElement, responseArray, photoArray, fullForm, isFollowUp);
                });
              }
            });
          }
          break;
        }
        case 'externalSubformId': {
          // Do not render this section on worklogs
          break;
        }
        case 'title': {
          // Handle staticText and sectionHeader - only render specific element IDs
          const allowedStaticTextIds = ['typeOfFacility', 'excavationType'];
          if (element.title && allowedStaticTextIds.includes(element.element_id)) {
            responseArray.push(element.title);
          }
          break;
        }
        default:
          if (element.type === 'counter') {
            responseArray.push(`${element.counterText}: ${element[responseType]}`);
          } else {
            responseArray.push(`${element.title} : ${element[responseType]}`);
          }
          break;
      }
    }
  }
};

export const parseForm = form => {
  const responseArray = [];
  const photoArray = [];

  if (!form || typeof form !== 'string') {
    return { responseArray, photoArray };
  }

  let parsedForm;
  try {
    parsedForm = JSON.parse(form);
  } catch (_err) {
    return { responseArray, photoArray };
  }

  if (!parsedForm || !Array.isArray(parsedForm.sections)) {
    return { responseArray, photoArray };
  }

  parsedForm.sections.forEach(section => {
    if (section && Array.isArray(section.elements)) {
      section.elements.forEach(element => {
        parseFormElement(element, responseArray, photoArray, parsedForm);
      });
    }
  });

  return { responseArray, photoArray };
};
